
import { defineComponent, onMounted, onUnmounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { getIllustrationsPath } from "@/core/helpers/assets";
import Messages from "@/core/helpers/Messages";
export default defineComponent({
  name: "auth",
  components: {},

  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });
    const errors = computed(() => {
      return store.getters.getErrors;
    });
    watch(errors, (newErrors) => {
      if (Object.keys(newErrors).length > 0) {
        Messages.showError(newErrors);
      }
    });
    return {
      getIllustrationsPath,
    };
  },
});
